import SafetyDOM from '@kopapro/components/commons/safetyDOM/safetyDOM';

export default SafetyDOM;
